import { type ComponentPropsWithoutRef } from 'react';
import { type PlanType } from '@/types';
import { cn } from '@/utils/tailwind.util';
import { AVATAR_BG_COLOR, type AvatarShape, type AvatarSize, DEFAULT_AVATAR_IMAGE, PLAN_GRADIENT_CLASS, SHAPE_MAP, SIZE_MAP } from '../constants/avatar.constants';
export const FallbackAvatar = ({
  size = 'xs',
  shape = 'circle',
  planType,
  backgroundColor,
  className,
  style,
  ...props
}: ComponentPropsWithoutRef<'div'> & {
  size?: AvatarSize;
  shape?: AvatarShape;
  planType?: PlanType;
  backgroundColor?: string;
}) => {
  const plan = planType ?? 'FREE';
  const gradientClass = PLAN_GRADIENT_CLASS[plan];
  const shapeClass = SHAPE_MAP[shape];
  if (!gradientClass) {
    return <div className={cn('relative inline-flex aspect-square shrink-0 overflow-hidden', shapeClass, SIZE_MAP[size], className)} style={style} {...props}>
        <img src={DEFAULT_AVATAR_IMAGE} alt="" className="size-full object-cover" />
      </div>;
  }
  return <div className={cn('relative inline-flex aspect-square shrink-0 p-[2px]', shapeClass, gradientClass, SIZE_MAP[size], className)} style={style} {...props} data-sentry-component="FallbackAvatar" data-sentry-source-file="FallbackAvatar.tsx">
      <div className={cn('flex aspect-square size-full items-center justify-center overflow-hidden', shapeClass)} style={{
      backgroundColor: backgroundColor ?? AVATAR_BG_COLOR
    }}>
        <img src={DEFAULT_AVATAR_IMAGE} alt="" className="size-full object-cover" />
      </div>
    </div>;
};